import { WidgetViewExtension } from '@blocksuite/std';
import { literal, unsafeStatic } from 'lit/static-html.js';

import { HIVE_VIEWPORT_OVERLAY_WIDGET } from '../widgets/viewport-overlay/viewport-overlay.js';

export const viewportOverlayWidget = WidgetViewExtension(
  'hive:page',
  HIVE_VIEWPORT_OVERLAY_WIDGET,
  literal`${unsafeStatic(HIVE_VIEWPORT_OVERLAY_WIDGET)}`
);
